export const Bio = {
  name: "Muhammad Arham",
  roles: [
    "Software Engineer",
    "AI Engineer",
    "ML Engineer",
    "Programmer",
    "MERN Stack Developer",
  ],
  description:
    "As a software engineer specializing in AI-driven solutions, I excel in developing web (MERN) and mobile (React Native) applications while mentoring students in programming at platforms like iCodeGuru and Aspire Pakistan. With extensive experience in global hackathons and coding challenges, I bring innovation and collaboration to every project. My expertise spans Generative AI, LLMs, and advanced tech ecosystems.",
  github: "https://github.com/arhamansari11",
  resume:
    "https://drive.google.com/file/d/1zDdteIwshZOts0jvqesWf6XGFJtVwXZL/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/arhamansari12/",
  twitter: "https://leetcode.com/u/arhamansari12/",
  insta: "https://www.instagram.com/heyyyyy_arham/",
  facebook: "https://www.facebook.com/profile.php?id=100069458314356",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://img.icons8.com/?size=100&id=11935&format=png&color=000000",
      },

      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      }
      ,
      {
        name: "Tailwind CSS",
        image: "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg",
      },
      {
        name: "JavaScript",
        image:
          "https://img.icons8.com/?size=100&id=108784&format=png&color=000000",
      },
      {
        name: "Next JS",
        image: "https://www.vectorlogo.zone/logos/nextjs/nextjs-icon.svg",
      },
      {
        name: "React JS",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Ant Design",
        image: "https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Php",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },

      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },

      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "Machine Learning",
    skills: [
      {
        name: "Python",
        image:
          "https://www.vectorlogo.zone/logos/python/python-icon.svg",
      },
      {
        name: "TensorFlow",
        image:
          "https://www.vectorlogo.zone/logos/tensorflow/tensorflow-icon.svg",
      },
      {
        name: "Jupyter",
        image:
          "https://www.vectorlogo.zone/logos/jupyter/jupyter-icon.svg",
      },
      {
        name: "NumPy",
        image:
          "https://www.vectorlogo.zone/logos/numpy/numpy-icon.svg",
      },
      {
        name: "Pandas",
        image:
          "https://www.vectorlogo.zone/logos/usepanda/usepanda-icon.svg",
      },
      {
        name: "PyCharm",
        image:
          "https://img.icons8.com/?size=100&id=117121&format=png&color=000000",
      },
      {
        name: "Streamlit",
        image: "https://img.icons8.com/?size=100&id=Rffi8qeb2fK5&format=png&color=000000",
      },
      {
        name: "PyTorch",
        image:
          "https://www.vectorlogo.zone/logos/pytorch/pytorch-icon.svg",
      },
      {
        name: "Google Colab",
        image:
          "https://img.icons8.com/?size=100&id=lOqoeP2Zy02f&format=png&color=000000",
      },
    ],
  },
  {
    title: "Languages",
    skills: [
      {
        name: "Php",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "Python",
        image: "https://www.vectorlogo.zone/logos/python/python-icon.svg",
      },
      {
        name: "JavaScript",
        image:
          "https://img.icons8.com/?size=100&id=108784&format=png&color=000000",
      },
      {
        name: "TypeScript",
        image:
          "https://www.vectorlogo.zone/logos/typescriptlang/typescriptlang-icon.svg"
      },
      {
        name: "C++",
        image:
          "https://img.icons8.com/?size=100&id=40669&format=png&color=000000"
      },
      {
        name: "JAVA",
        image:
          "https://www.vectorlogo.zone/logos/java/java-icon.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Stack OverFlow",
        image:
          "https://www.vectorlogo.zone/logos/stackoverflow/stackoverflow-icon.svg",
      },
      {
        name: "Netlify",
        image:
          "https://img.icons8.com/?size=100&id=YsPdguLCFOMH&format=png&color=000000",
      },
      {
        name: "VS Code",
        image:
          "https://img.icons8.com/?size=100&id=9OGIyU8hrxW5&format=png&color=000000"
      },
      {
        name: "Vercel",
        image:
          "https://www.vectorlogo.zone/logos/vercel/vercel-icon.svg",
      },
      {
        name: "Postman",
        image:
          "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
      },
      {
        name: "Surge",
        image:
          "https://www.vectorlogo.zone/logos/surgesh/surgesh-icon.svg",
      },
      {
        name: "Figma",
        image:
          "https://www.vectorlogo.zone/logos/figma/figma-icon.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    role: "Section Leader",
    company: "Stanford University",
    date: "April 2026 - July 2026",
    desc: "Selected as Section Leader among ~1400 all over the world to teach CS106A to 10-15 group of international students.",
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7475559573131771904/",
    linkText: " 𝐂𝐞𝐫𝐭𝐢𝐟𝐢𝐜𝐚𝐭𝐞 𝐨𝐟 𝐄𝐱𝐜𝐞𝐥𝐥𝐞𝐧𝐜𝐞 𝐢𝐧 𝐓𝐞𝐚𝐜𝐡𝐢𝐧𝐠 𝐚𝐧𝐝 𝐌𝐞𝐧𝐭𝐨𝐫𝐬𝐡𝐢𝐩  ",
    skills: [
      "LeaderShip",
      "Mentor",
      "Moderator",
      "Instructor",
      "Python",
      "Section Leader",
      "LeeetCode",
      "Coding",
    ],
    doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ"
  },
  {
    id: 0,
    role: "Moderator and Trainer",
    company: "iCodeGuru",
    date: "Dec 2023 - Present",
    desc: "Moderated a 22,000+ member community, teaching DSA in Python via workshops, interactive sessions, and weekly classes for underprivileged students. Organized sessions on Hackathons, GitHub, Recursion, and Machine Learning.",
    link: "https://github.com/arhamansari11/volunteer_Teaching_Recordings",
    linkText: " (𝐏𝐲𝐭𝐡𝐨𝐧, 𝐃𝐒𝐀, & 𝐋𝐞𝐞𝐭𝐂𝐨𝐝𝐞) 𝐏𝐥𝐚𝐲𝐥𝐢𝐬𝐭  ",
    skills: [
      "LeaderShip",
      "Mentor",
      "Moderator",
      "Instructor",
      "DSA",
      "Data Structures and Alogrithms",
      "LeeetCode",
      "Coding",
    ],
    doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ"
  },
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/C560BAQFQb9_Lb3bZug/company-logo_200_200/0/1644414857251?e=1693440000&v=beta&t=7WqhIiUCg_0otFDwWn-O_SP-Z4Ftoe4be1WlnjYoESc",
    role: "Instructor and Mentor",
    company: "Pak Angels",
    date: "June 2024 - Present",
    desc: "Training and moderating students freely during the Generative-AI course with over 10,000 registrants. Providing Python programming language instruction and hosting webinars highlighting the significance of LeetCode.",
    doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7262493666353500161/",
    linkText: "𝐂𝐞𝐫𝐭𝐢𝐟𝐢𝐜𝐚𝐭𝐞 𝐨𝐟 𝐄𝐱𝐜𝐞𝐥𝐥𝐞𝐧𝐜𝐞 𝐢𝐧 𝐓𝐞𝐚𝐜𝐡𝐢𝐧𝐠 𝐚𝐧𝐝 𝐌𝐞𝐧𝐭𝐨𝐫𝐬𝐡𝐢𝐩",
    skills: [
      "LeaderShip",
      "Mentor",
      "Moderator",
      "Instructor",
      "GEN AI",
      "RAG",
      "Python Programming",
      "Coding",
    ],
  },
  {
    id: 2,
    img: "https://media.licdn.com/dms/image/C510BAQGSObrO0QPlMQ/company-logo_200_200/0/1555704980721?e=1692835200&v=beta&t=FjOWcUVVNzqFbTmmp0iXQkv5keBQC5lxIQ7K6rmMSMQ",
    role: "Hackathon Participant ",
      company: "lablab.ai",
      date: "Dec 2023 - Present",
 
    desc: " Participated in numerous LabLab Hackathons, fostering innovation and collaboration within the IT industry. Applied MERN stack and Artificial Intelligence expertise to solve complex challenges and develop creative solutions during hackathons.",
    doc: "https://media.licdn.com/dms/image/D4D22AQGzSpgFaR4hsQ/feedshare-shrink_800/0/1684079632872?e=1687996800&v=beta&t=i0xWn_k32Oj9SxKfc6rARSbOghXD9Ge6WyEb2p2vvrc",
    link: "https://lablab.ai/u/@Arhamansari",
    linkText: "𝐋𝐚𝐛𝐋𝐚𝐛 𝐏𝐫𝐨𝐟𝐢𝐥𝐞",
    skills: [
      "Leadership",
      "Effective Communication",
      "Team Collaboration",
      "Team Building",
      "Generative AI Expertise",
      "Project Management",
      "Time Optimization",
      "Programming",
    ],    
  },
  {
    id: 3,
    img: "https://media.licdn.com/dms/image/D4D0BAQGfGQHEJt8gPA/company-logo_100_100/0/1666002815185?e=1692230400&v=beta&t=c4obZda4Uh9q6vOcmCbxjoSiExvbvYwEHUlgdY0tU-4",
    role: "MERN-Stack Software Developer",
    company: "PersonaNet by Afterflea",
    date: "Mar 2024 - Jun 2024",
    desc: "Developing scalable and robust APIs alongside efficient backend systems using technologies like 𝗠𝗼𝗻𝗴𝗼𝗗𝗕, 𝗙𝗶𝗿𝗲𝗯𝗮𝘀𝗲, 𝗮𝗻𝗱 𝗘𝘅𝗽𝗿𝗲𝘀𝘀.𝗷𝘀. Leveraging frameworks such as 𝗗𝗷𝗮𝗻𝗴𝗼 𝗥𝗲𝘀𝘁, 𝗙𝗹𝗮𝘀𝗸, 𝗮𝗻𝗱 𝗡𝗲𝘅𝘁.𝗷𝘀 to build seamless, high- performance applications. ",
    skills: [
      "Web Application Development",
      "MongoDB",
      "Firebase",
      "ExpressJs",
      "NodJs",
      "Django",
      "Rest API",
      "Flask",
    ],
    link: "https://www.linkedin.com/posts/arhamansari12_internship-internshipjourney-startup-activity-7170289615449395200-v1Rr?utm_source=share&utm_medium=member_desktop",
    linkText: "InternShip Offer Letter"
  },
];

export const education = [
  {
    "id": 0,
    "school": "Virtual University of Pakistan",
    "date": "Sep 2024 - July 2028",
    "degree": "Bachelor of Science in Software Engineering",
    "grade": "A+",
    "desc": "Pursuing a Bachelor's degree in Software Engineering from Virtual University to build a strong academic foundation. Focusing on key areas such as Web Development and Artificial Intelligence (AI) for cutting-edge skills."
  },  
  {
    id: 1,
    school: "Superior Group of Colleges",
    date: "Sep 2021 - Aug 2023",
    grade: "60.02%",
    desc: "Successfully completed F.Sc Pre-Engineering, achieving excellent grades. Built a strong foundation in mathematics, physics, and engineering principles during my studies.",
    degree: "F.S.C Pre Engineering  ",
  },
  {
    id: 2,
    school: "Anmol Public High School, Faisalabad",
    date: "Aug 2019 - Sep 2021",
    grade: "92.3%",
    desc: "Completed Class 10 education at Anmol Public High School, Faisalabad. Studied Science with a focus on Computer.",
    degree: "Science with Computer",
  },
];

export const projects = [
  {
    id: 9,
    title: "Student Management System",
    description:
      "Student Mangement System is a web application.Student Management System app are created with React for the front end and Firebase for the backend.Easily perform basic CRUD operations on student records.Get instant updates using Firebase for real-time data changes.",
    image:
      "https://github.com/arhamansari11/Student-Management-System/blob/main/admin.png?raw=true",
    tags: [
      "Html",
      "CSS",
      "Bootstrap",
      "Ant Design",
      "Material UI",
      "Graph Js",
      "Javascript",
      "React Js",
      "Firebase",
      "Firestore"
    ],
    category: "web app",
    github: "https://github.com/arhamansari11/Student-Management-System",
    webapp: "https://student-ms-admin.netlify.app/",
  },
  {
    id: 0,
    title: "Doctor Appointment App",
    description:
      "Developed a full-stack web application that allows users to search for doctor , and set appointment.Made responsive user interface with React JS that provides users with a seamless experience across all devices.",
    image:
      "https://github.com/arhamansari11/Final-Hackathon-SMIT/blob/main/dr.png?raw=true",
    tags: ["React Js", "MongoDb", "Node Js", "Express Js"],
    category: "web app",
    github: "https://github.com/arhamansari11/Final-Hackathon-SMIT",
    webapp: "https://github.com/arhamansari11/Final-Hackathon-SMIT",
  },
  {
    id: 1,
    title: "Software Project",
    description:
      "Designed and developed the Software project.Made responsive user interface that provides users with a seamless experience across all devices",
    image:
      "https://github.com/arhamansari11/Software-Project/blob/master/sofwtare.png?raw=true",
    tags: [
      "HTML",
      "CSS",
      "Bootstrap",
      "JavaScript",
    ],
    category: "web app",
    github: "https://github.com/arhamansari11/Software-Project",
    webapp: "https://software-project.netlify.app/",
  },
  {
    id: 2,
    title: "T-shirt-Shop",
    description:
      "Designed and developed the T-shirt-Shop.Made responsive user interface that provides users with a seamless experience across all devices",
    image:
      "https://github.com/arhamansari11/T-shirt-Shop/blob/master/shirt.png?raw=true",
    tags: [
      "HTML",
      "CSS",
      "Bootstrap",
      "JavaScript",
    ],
    category: "webapp",
    github: "https://github.com/arhamansari11/T-shirt-Shop",
    webapp: "https://t-shirtshop-store.netlify.app/",
  },
  {
    id: 5,
    title: "Todo Web App",
    description:
      " A Todo Web App made with HTML,CSS,JS, PHP, MYSql. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
    image:
      "https://github.com/arhamansari11/PHP-Classes/blob/master/Todo%20App%20List/todo.png?raw=true",
    tags: [
      "HTML",
      "CSS",
      "Bootstrap",
      "JavaScript",
      "Php",
      "MySql"
    ],
    category: "web app",
    github: "https://github.com/arhamansari11/PHP-Classes/tree/master/Todo%20App%20List",
    webapp: "https://github.com/arhamansari11/PHP-Classes/tree/master/Todo%20App%20List",
  },
  {
    id: 10,
    title: "Zay Shop",

    description:
      "A Job Finding App made with React Native, Axios. Users can search for any job coming from API and apply there.",
    image:
      "https://github.com/arhamansari11/Zay-shop/blob/master/zat.png?raw=true",
    tags: [
      "HTML",
      "CSS",
      "Bootstrap",
      "JavaScript",
    ],
    github: "https://github.com/arhamansari11/Zay-shop",
    webapp: "https://zay-shop.surge.sh/",
  },
  {
    id: 4,
    title: "Backend Developement Repository",
    description:
      "This repository has been created to provide you with practical examples of the concepts to covered Backend Developement. My goal is to help you better understand the theoretical concepts by providing you with real-world scenarios and code samples.",
    image:
      "https://github.com/arhamansari11/Backend-Developement/blob/master/repo.png?raw=true",
    tags:
     ["Node Js", "Express Js", "Mongo Db", "Postman" , "Morgan" , "Mongoogse"]
     ,
    category: "web app",
    github: "https://github.com/arhamansari11/Backend-Developement",
    webapp: "https://github.com/arhamansari11/Backend-Developement",
  },
  {
    id: 4,
    title: "LeetCode Starter Kit Repository",
    description:
      "This repository contains links to LeetCode problems that I've solved, specially curated for beginners. Each problem is categorized by difficulty and topic, making it easy for you to navigate and practice. Start your coding journey here and build a strong foundation in problem-solving!",
    image:
      "https://github.com/arhamansari11/LeetCode-Starter-Kit/blob/main/Leetcode.png?raw=true",
    tags:
     ["LeetCode", "Coding", "Programming", "Problem Solving"]
     ,
    category: "web app",
    github: "https://github.com/arhamansari11/LeetCode-Starter-Kit/",
    webapp: "https://github.com/arhamansari11/LeetCode-Starter-Kit/",
  },

  {
    id: 6,
    title: "Mini Projects Repository",
    description:
      "Simple Animations repository! In this repository, you will find a collection of simple animations created using HTML, CSS, and JavaScript. These animations are designed to provide a foundation for learning and experimenting with basic web animations.",
    image:
      "https://github.com/arhamansari11/Mini-Projects/blob/master/repo1.png?raw=true",
    tags: ["HTML", "CSS", "Javascript", "Animation" ],
    category: "web app",
    github: "https://github.com/arhamansari11/Mini-Projects",
    webapp: "https://github.com/arhamansari11/Mini-Projects",
  }
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
